import { createApiClient } from 'ozira-app-core';
import { getConfig, getEnvironment } from '../env';
import { supabase } from './supabaseClient';

const config = getConfig();

// Hosted OZIRA deployments serve the UI and API from the same Railway
// service. Resolve the API against the active page origin so a stale or
// unavailable custom staging DNS record cannot make authentication appear to
// fail after Supabase has already issued a valid session.
const apiBase = typeof window !== 'undefined' && getEnvironment() !== 'development'
  ? window.location.origin
  : config.apiBase;

// The ONE typed OZIRA API client for this app (spec section 19-20). Every
// screen calls through this, never a raw fetch() -- see UI -> hook -> this
// client -> ozira-ai (section 20).
export const apiClient = createApiClient({
  baseUrl: apiBase,
  getToken: async () => {
    const { data } = await supabase.auth.getSession();
    return data.session?.access_token ?? null;
  },
  refreshToken: async () => {
    const { data } = await supabase.auth.refreshSession();
    return data.session?.access_token ?? null;
  },
  defaultHeaders: { 'x-ozira-platform': 'web' },
});
